module.exports = __webpack_public_path__ + "img/work2.86027158.png";